module.exports = __webpack_public_path__ + "media/icons/copy-link-c1438bf0.svg";